import { useEffect, useRef } from 'react';

/**
 * Ejecuta `onOpen` UNA sola vez por apertura del modal, es decir cuando
 * `isOpen` transita de `false` a `true`. No depende de ningún otro valor:
 * cualquier dato adicional que necesite el callback se lee por closure al
 * momento de abrir, por lo que cambios de referencia en colecciones globales
 * (clients, salespersons, etc.) o re-renders por refresh de auth no van a
 * resetear el formulario abierto.
 *
 * Uso típico:
 *   useOnOpen(isOpen, () => {
 *     setItems([]);
 *     setSalesperson(getDefaultSalesperson());
 *     ...
 *   });
 */
export function useOnOpen(isOpen: boolean, onOpen: () => void) {
  const wasOpenRef = useRef(false);
  const onOpenRef = useRef(onOpen);
  // Mantenemos la referencia actualizada para evitar cierres viejos.
  onOpenRef.current = onOpen;

  useEffect(() => {
    if (isOpen && !wasOpenRef.current) {
      wasOpenRef.current = true;
      onOpenRef.current();
    } else if (!isOpen && wasOpenRef.current) {
      wasOpenRef.current = false;
    }
  }, [isOpen]);
}
